import { useQuery } from '@tanstack/react-query';
import { VendorService } from '../VendorService';

export const useVendors = (activeOnly = false) =>
  useQuery({
    queryKey: ['vendors', 'list', activeOnly],
    queryFn: () => VendorService.listVendors(activeOnly),
  });
